import { render } from "./Docs.vue?vue&type=template&id=e90a5afa&scoped=true"
import script from "./Docs.vue?vue&type=script&lang=js"
export * from "./Docs.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-e90a5afa"

export default script